// src/components/payments/PayExpressBadge.js
// ============================================================
// MARQUE "PAYEXPRESS" — nom a donner au guichet
// ------------------------------------------------------------
// Payzone est la passerelle TECHNIQUE de Maxula ; au comptoir, les
// agences (Cash Plus, Barid Cash, Damane Cash, Lana Cash) ne
// connaissent que l'enseigne PAYEXPRESS. Un client qui dit "Payzone"
// se fait renvoyer : l'agent ne sait pas de quoi il parle.
// Ce composant affiche la marque telle qu'elle est reconnue au guichet.
//
// LOGO OFFICIEL : deposez le fichier fourni par PayExpress dans
// `public/payexpress-logo.png`. S'il est absent, le composant bascule
// automatiquement sur un badge texte lisible — rien ne casse.
// ============================================================

import React, { useState } from 'react';

const PayExpressBadge = ({ size = 'md', className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false);

  const heights = { sm: 'h-6', md: 'h-9', lg: 'h-12' };
  const textSizes = { sm: 'text-xs', md: 'text-sm', lg: 'text-base' };

  if (imgFailed) {
    // Repli texte : reprend les deux couleurs de l'enseigne pour rester
    // reconnaissable meme sans le fichier logo.
    return (
      <span
        className={`inline-flex items-center rounded font-extrabold tracking-tight overflow-hidden border border-gray-200 ${textSizes[size] || textSizes.md} ${className}`}
      >
        <span className="bg-[#1f7a8c] text-white px-2 py-1">PAY</span>
        <span className="bg-[#e8452c] text-white px-2 py-1">EXPRESS</span>
      </span>
    );
  }

  return (
    <img
      src="/payexpress-logo.png"
      alt="PayExpress"
      onError={() => setImgFailed(true)}
      className={`${heights[size] || heights.md} w-auto object-contain ${className}`}
    />
  );
};

export default PayExpressBadge;
